import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "gatsby";

function Clientcloud() {
  return (
    <section className="client_cloud p-100">
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} xl={8} xxl={8}>
            <h2>
              8 Reasons to Opt for Tekrevol’s <span>DevOps Enablement</span>
            </h2>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              //   autoplay={false}
              spaceBetween={20}
              modules={[Autoplay, Pagination]}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
                1366: {
                  slidesPerView: 3,
                },
                1600: {
                  slidesPerView: 3,
                },
              }}
              className="client_cloud_slider devops_eight_slider"
            >
              <SwiperSlide>
                <div className="client_cloud_box devops_eight_box">
                  <div className="client_cloud_content">
                    <h5>Improved Agility</h5>
                    <p>
                      Our DevOps enablement services ensure that you can deliver
                      product at high velocity. This collaborative framework is
                      bound to enhance communication, improve feedback, and
                      reduce the time to updates. It will improve overall
                      frequency of delivery, while leveraging CI/CD for faster
                      pipelines. As a result, the application development teams
                      will be rewarded with greater customer satisfaction.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box devops_eight_box">
                  <div className="client_cloud_content">
                    <h5>Greater Value</h5>
                    <p>
                      By joining hands with our DevOps enablement team, you
                      unlock immense value for your product development, and
                      operations. We leverage Continuous integration, and
                      Continuous delivery to ensure that changes are
                      automatically saved, and updated. This provides you with
                      an agile system that is capable of adapting to changing
                      business scenarios, while also increasing the frequency of
                      rollbacks.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box devops_eight_box">
                  <div className="client_cloud_content">
                    <h5>High-Level Scalability</h5>
                    <p>
                      DevOps enablement comes up with high-level scalability. We
                      guide teams to build a DevOps receptive culture model that
                      fosters a sense of proud ownership, and accountability.
                      Plus, it fosters consistency and automation, enabling
                      leadership figures to consider the big picture, and
                      enforce essential risk controls.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box devops_eight_box">
                  <div className="client_cloud_content">
                    <h5>Enhanced Security</h5>
                    <p>
                      A major smart benefit of automated DevOps enablement is
                      apparent in the form of enhanced security. This happens
                      through system administrators streamlining configuration
                      of security processes, and policies. Their endeavors are
                      directed at optimizing operations while automating
                      standardized, yet repeatable configuration updates.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box devops_eight_box">
                  <div className="client_cloud_content">
                    <h5>Minimized Costs</h5>
                    <p>
                      DevOps enablement calls for on-demand use of cloud
                      infrastructure. This translates into a significant
                      reduction in spending, while also preparing time-savvy
                      workflows. On-demand use of cloud-base ensures that
                      resources are only used when required. Hence, DevOps
                      ensures resource optimization
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="client_cloud_box devops_eight_box">
                  <div className="client_cloud_content">
                    <h5>Collaborative Mode</h5>
                    <p>
                      DevOps enablement teams add significant value to the
                      business process by aligning both operations, and
                      development teams. It fosters a favorable culture for
                      cross-functional collaboration. As a result, operations
                      and developers share responsibilities, and work closely
                      together to streamline workflows thus offering a greater
                      functional integration.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box devops_eight_box">
                  <div className="client_cloud_content">
                    <h5>Smooth Operations</h5>
                    <p>
                      By leveraging this framework for development and delivery
                      service providers can be more confident about their
                      delivery mechanism as DevOps enablement gives increased
                      visibility into work, while also improves tracking so you
                      can propose changes and seek prompt resolution of issues
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box devops_eight_box">
                  <div className="client_cloud_content">
                    <h5>Super-Efficient Dev Cycles</h5>
                    <p>
                      One primary reason to invest in DevOps enablement is the
                      shortened, yet effective development cycles. With DevOps,
                      service providers can increase frequency of releasing
                      software, this leaves them with the freedom, and time to
                      research, and innovate. As a result, they can continue to
                      build more feature-rich tech products.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clientcloud;
